import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PBApi, PBProfile } from 'src/app/core/api.gen';
import { UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'eos-dep-flight-booking',
  templateUrl: './dep-flight-booking.component.html',
  styleUrls: ['./dep-flight-booking.component.css']
})
export class DepFlightBookingComponent implements OnInit {
  @Input() candidateId: number;
  @Input() model: PBProfile ;
  @Input() step: any;
  @Input() form= new UntypedFormGroup({})
  @Output() updateComplete = new EventEmitter<any>(); 
  constructor(public modal:NgbModal,private pbApi:PBApi) { }

  ngOnInit(): void {
  }

  close(){
    this.modal.dismissAll();
  }

  submit(){ 
    this.pbApi.updateFlightBookingDate(this.candidateId,this.model.depDateOfIntiation,this.model.depDateOfCompletion).subscribe(
      res=>{
        if(res){
          this.updateComplete.emit(this.model);
          this.close();
        }
        
      },
      err=>{

      }
    );
  }
}
